import { useTranslation } from 'react-i18next';
import { Link } from '../../components/base/Link';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function FileRedaction() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        {/* 科技背景 - 保持所有动画效果不变 */}
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900"></div>

        <div className="relative max-w-7xl mx-auto px-6 z-10">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {t('fileRedaction.heroTitle')}
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              {t('fileRedaction.heroSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* 功能亮点 */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('home.featuresTitle')}</h2>
            <p className="text-lg text-gray-600">{t('home.featuresSubtitle')}</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-brand-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-list-3-line text-2xl text-brand-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('fileRedaction.feature1Title')}</h3>
              <p className="text-gray-600">{t('fileRedaction.feature1Desc')}</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-pages-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('fileRedaction.feature2Title')}</h3>
              <p className="text-gray-600">{t('fileRedaction.feature2Desc')}</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-brand-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-layout-line text-2xl text-brand-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('fileRedaction.feature3Title')}</h3>
              <p className="text-gray-600">{t('fileRedaction.feature3Desc')}</p>
            </div>
          </div>
        </div>
      </section>


      {/* 支持的格式与导出选项 */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('fileRedaction.formatsTitle')}</h2>
            <p className="text-lg text-gray-600">{t('fileRedaction.formatsSubtitle')}</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-file-pdf-line text-3xl text-brand-600 mb-2"></i>
              <div className="font-medium text-gray-900">{t('fileRedaction.pdf')}</div>
              <div className="text-sm text-gray-600">{t('fileRedaction.pdfDesc')}</div>
            </div>
            
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-file-word-line text-3xl text-blue-600 mb-2"></i>
              <div className="font-medium text-gray-900">{t('fileRedaction.word')}</div>
              <div className="text-sm text-gray-600">{t('fileRedaction.wordDesc')}</div>
            </div>
            
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-file-excel-line text-3xl text-brand-600 mb-2"></i>
              <div className="font-medium text-gray-900">{t('fileRedaction.excel')}</div>
              <div className="text-sm text-gray-600">{t('fileRedaction.excelDesc')}</div>
            </div>
            
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-file-ppt-line text-3xl text-brand-600 mb-2"></i>
              <div className="font-medium text-gray-900">{t('fileRedaction.ppt')}</div>
              <div className="text-sm text-gray-600">{t('fileRedaction.pptDesc')}</div>
            </div>
            
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-file-text-line text-3xl text-gray-600 mb-2"></i>
              <div className="font-medium text-gray-900">{t('fileRedaction.txt')}</div>
              <div className="text-sm text-gray-600">{t('fileRedaction.txtDesc')}</div>
            </div>
            
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <i className="ri-file-line text-3xl text-brand-600 mb-2"></i>
              <div className="font-medium text-gray-900">{t('fileRedaction.rtf')}</div>
              <div className="text-sm text-gray-600">{t('fileRedaction.rtfDesc')}</div>
            </div>
          </div>
        </div>
      </section>

      {/* 应用场景 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('fileRedaction.scenariosTitle')}</h2>
            <p className="text-lg text-gray-600">{t('fileRedaction.scenariosSubtitle')}</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-contract-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('fileRedaction.scenario1Title')}</h3>
              <p className="text-gray-600 text-sm">
                {t('fileRedaction.scenario1Desc')}
              </p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hospital-line text-2xl text-brand-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('fileRedaction.scenario2Title')}</h3>
              <p className="text-gray-600 text-sm">
                {t('fileRedaction.scenario2Desc')}
              </p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-government-line text-2xl text-brand-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('fileRedaction.scenario3Title')}</h3>
              <p className="text-gray-600 text-sm">
                {t('fileRedaction.scenario3Desc')}
              </p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-16 h-16 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-2xl text-brand-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('fileRedaction.scenario4Title')}</h3>
              <p className="text-gray-600 text-sm">
                {t('fileRedaction.scenario4Desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 技术优势 */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('fileRedaction.techTitle')}</h2>
            <p className="text-lg text-gray-600">{t('fileRedaction.techSubtitle')}</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('fileRedaction.tech1Title')}</h3>
              <p className="text-gray-600">
                {t('fileRedaction.tech1Desc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-layout-masonry-line text-3xl text-brand-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('fileRedaction.tech2Title')}</h3>
              <p className="text-gray-600">
                {t('fileRedaction.tech2Desc')}
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-brand-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-3xl text-brand-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('fileRedaction.tech3Title')}</h3>
              <p className="text-gray-600">
                {t('fileRedaction.tech3Desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-brand-navy">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            {t('fileRedaction.ctaTitle')}
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            {t('fileRedaction.ctaSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/pricing#contact" className="bg-white text-brand-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              {t('fileRedaction.ctaButton1')}
            </Link>
            <Link to="/pricing" className="bg-brand-700 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-800 transition-colors border border-brand-600 whitespace-nowrap cursor-pointer">
              {t('fileRedaction.ctaButton2')}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
